var _style, _desc, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigmaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 300",
    width: 1667,
    height: 2500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#0acf83}.st1{fill:#a259ff}.st2{fill:#f24e1e}.st3{fill:#ff7262}.st4{fill:#1abcfe}")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Figma.logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    className: "st0",
    d: "M50 300c27.6 0 50-22.4 50-50v-50H50c-27.6 0-50 22.4-50 50s22.4 50 50 50z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1_fill",
    className: "st1",
    d: "M0 150c0-27.6 22.4-50 50-50h50v100H50c-27.6 0-50-22.4-50-50z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path1_fill_1_",
    className: "st2",
    d: "M0 50C0 22.4 22.4 0 50 0h50v100H50C22.4 100 0 77.6 0 50z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path2_fill",
    className: "st3",
    d: "M100 0h50c27.6 0 50 22.4 50 50s-22.4 50-50 50h-50V0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path3_fill",
    className: "st4",
    d: "M200 150c0 27.6-22.4 50-50 50s-50-22.4-50-50 22.4-50 50-50 50 22.4 50 50z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaLogo);
export default __webpack_public_path__ + "static/media/Figma-logo.0f4098dccb2a84e24331b00bc6a8dcf8.svg";
export { ForwardRef as ReactComponent };